'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function easeOutCubic(currentIteration, startValue, changeInValue, totalIterations) {
  return changeInValue * (Math.pow(currentIteration / totalIterations - 1, 3) + 1) + startValue;
}

var FUNCTIONS = Object.freeze({
  easeOutCubic: easeOutCubic
});

function snap($el, to, scroll, _ref) {
  var _ref$delay = _ref.delay,
      delay = _ref$delay === undefined ? 10 : _ref$delay,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 75 : _ref$duration,
      _ref$fn = _ref.fn,
      fn = _ref$fn === undefined ? 'easeOutCubic' : _ref$fn,
      _ref$step = _ref.step,
      step = _ref$step === undefined ? 5 : _ref$step;

  var currentTime = 0;
  var next = FUNCTIONS[fn] || easeOutCubic;
  var start = $el[scroll];
  var change = to - start;

  var animate = function animate() {
    currentTime += step;

    $el[scroll] = next(currentTime, start, change, duration);

    if (currentTime < duration) {
      requestAnimationFrame(animate);
    }
  };

  setTimeout(animate, delay);
}

function snapY($el, to) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  snap($el, to, 'scrollTop', options);
}

function snapX($el, to) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  snap($el, to, 'scrollLeft', options);
}

exports.snapY = snapY;
exports.snapX = snapX;